import React, { useEffect, useState,useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Navbar from "../../Navbar/Navbar.js";
import Dedicated from "../../../Images/Dedicated-development-teams.svg";
import Footer from "../../Footer/Footer.js";
import DetailsCard, { ThreeColumnContainer } from "./DetailsCard.js";
import cardData from "../../../resources/cardData.json";
import imageHeader from "../../../resources/imageHeader.json";
import SubHeadings from "./SubHeadings.js";
import DescriptionContainer from "./DescriptionContainer.js";
import { ReactComponent as DollarIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Trending } from "feather-icons/dist/icons/trending-up.svg";
import { ReactComponent as Award } from "feather-icons/dist/icons/award.svg";
import { ReactComponent as Flexibility } from "feather-icons/dist/icons/refresh-ccw.svg";
import { ReactComponent as Collab } from "feather-icons/dist/icons/users.svg";
import { ReactComponent as Clock } from "feather-icons/dist/icons/clock.svg";
import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../../Navbar/Navbar.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs.js";

import ContactUsButton from "./ContactUsButton.js";
import TechStack1 from "./TechStack1.js";
import ImageHeaderMain from "./ImageHeaderMain.js";
const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-800 bg-white z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const ContainerNav = styled.div`
  ${tw`relative`}
`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;
const Description = tw.p`mt-4 p-2 text-justify md:text-justify text-lg md:text-base lg:text-lg font-medium leading-relaxed text-secondary-500`;
const KeyBenefitsContainer = styled.div`
  ${tw`mb-8 flex flex-row justify-center `}

  @media screen and (max-width: 1280px) {
    & {
      display: flex;
      flex-wrap: wrap;
    }
  }
`;

let data = [
  {
    imageSrc: <Award />,
  },
  {
    imageSrc: <Trending />,
  },
  {
    imageSrc: <DollarIcon />,
  },
  {
    imageSrc: <Flexibility />,
  },
  {
    imageSrc: <Collab />,
  },
  {
    imageSrc: <Clock />,
  },
];
const keyBenefits = cardData.dedicated.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));

const DedicatedTeam = () => {
  const [animate, setAnimate] = useState(true);

  useEffect(()=>{
    document.title="Welcome to Iqura - Dedicated  Development Teams"
    let descMeta=document.querySelector("meta[name='description']")
    descMeta.setAttribute("content", 'Iqura provides you with a group of skilled and experienced professionals committed solely to your projects, ensuring undivided attention and expertise.')
    let keyword=document.querySelector("meta[name='keywords']")
    keyword.setAttribute("content", "Expertise, Development Practices, Cost-Effectiveness, Flexibility, Collaborative Approach, Time Efficiency")
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = 'https://www.iqura.tech/our-services/dedicated-development-teams';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
    },[]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      setAnimate(false);
    }, 1400);
  }, []);

  const [currentColor, setCurrentColor] = useState("%23EEF5FF");
  const svgStyle = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='${currentColor}' fill-opacity='0.9' d='M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,80C960,75,1056,85,1152,117.3C1248,149,1344,203,1392,229.3L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'/%3E%3C/svg%3E")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height:"350px"
  };

  const navigate = useNavigate();
  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => navigate("/", { state: "whatwedo" })}>
        What we do
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "ourservices" })}>
        Services
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "techstack" })}>
        Techstack
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "whoweare" })}>
        Who we are
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "career" })}>
        Careers
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "contact" })}>
        Contact
      </NavLink>
    </NavLinks>,
  ];
  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };
  return (
    <>
    <Navbar className="shadow-md" />
      <ContainerNav>
        <OpacityOverlay />
        <HeroContainer>
          <StyledHeader links={navLinks} />
        </HeroContainer>
      </ContainerNav>

      <BreadCrumbs ref={childRef} title={"Dedicated  Development Teams"} title1={"Our services"}  bgcolor={"#EEF5FF"}/> 

      <ContactUsButton />
      <Container style={svgStyle} onClick={handleBreadCrumbClose}>
        <ImageHeaderMain
          imageHeaderData={imageHeader.dedicated}
          imgsource={Dedicated}
        />

        <Wrapper>
          <SubHeadings heading1="Key" heading2="benefits" />
          <ThreeColumnContainer>{keyBenefits}</ThreeColumnContainer>

          <DescriptionContainer data={cardData.dedicated.howItWorks} />
          <SubHeadings heading1="Our" heading2="Techstack" />
          <TechStack1/>
        </Wrapper>

        <Footer />
      </Container>
    </>
  );
};

export default DedicatedTeam;
